// frontend/src/pages/AddRegulation.jsx
import React, { useState } from "react";
import axios from "axios";
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import "./RegulationForm.css"; // 🎨 סגנונות משותפים להוספה/עדכון

const API = process.env.REACT_APP_API;

const AddRegulation = () => {
    const [title, setTitle] = useState("");
    const [file, setFile] = useState(null);
    const navigate = useNavigate();
    const { token } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!title) {
            toast.error("נא למלא את שם הקטיגוריה");
            return;
        }

        if (!file) {
            toast.error("נא להעלות קובץ");
            return;
        }

        try {
            const formData = new FormData();
            formData.append("title", title);
            formData.append("pdf", file);

            await axios.post(`${API}/api/regulations`, formData, {
                headers: { 
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`   // 👈 חובה
                },
            });

            toast.success("הקטיגוריה נוספה בהצלחה!");
            navigate("/regulations");
        } catch (err) {
            toast.error("שגיאה בהעלאת הקובץ");
        }
    };

    return (
        <div className="regulation-form-container">
            {/* אייקון הבית בפינה שמאלית עליונה */}
            <div className="home-icon">
                <IoHome title="עמוד הבית" size={30} onClick={() => navigate("/")}/>
            </div>
            <div className="back-icon">
                <PiKeyReturnFill title="חזרה לעמוד הקודם" size={40} onClick={() => navigate("/regulations")}/>
            </div>
        <h2>הוספת קטיגוריה חדשה</h2>
      <form onSubmit={handleSubmit} className="regulation-form">
        <input
          type="text"
          placeholder="כותרת הקטיגוריה"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <input type="file" onChange={(e) => setFile(e.target.files[0])} />
        
        <div className="buttons">
          <button type="submit">💾 שמירה</button>
          <button type="button" onClick={() => navigate("/regulations")}>⬅️ חזרה</button>
        </div>
      </form>
    </div>
    );
};

export default AddRegulation;
